/*تعمیرگاه*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      data-name="080---Car-Sale"
      xmlns="http://www.w3.org/2000/svg"
      width={89.175}
      height={89.17}
      viewBox="0 0 89.175 89.17"
      {...props}
    >
      <g transform="translate(1.486 1.419)">
        <path
          d="M29.724 23.846v6.807c-2.006.268-4.042.609-5.945 1.055v-7.862z"
          fill="sienna"
        />
        <path
          data-name="Shape"
          d="M62.419 23.846v7.877a58.346 58.346 0 00-5.945-1.07v-6.807z"
          fill="sienna"
        />
        <path
          data-name="Shape"
          d="M80.253 53.569c1.769 0 3.18.149 4.637-1.308a4.458 4.458 0 00-3.151-7.609H4.458a4.458 4.458 0 000 8.917z"
          fill="#c81e1e"
        />
        <path
          data-name="Shape"
          d="M23.779 74.375v8.917a2.972 2.972 0 01-2.972 2.972h-8.918a2.972 2.972 0 01-2.972-2.972v-8.917zM77.281 74.375v8.917a2.972 2.972 0 01-2.972 2.972h-8.918a2.972 2.972 0 01-2.972-2.972v-8.917z"
          fill="#37474f"
        />
        <rect
          width={71.218}
          height={23.739}
          rx={2}
          transform="translate(7.416)"
          fill="#c81e1e"
        />
        <rect
          data-name="Rectangle-path"
          width={66.979}
          height={23.739}
          rx={2}
          transform="translate(7.416)"
          fill="#f44335"
        />
        <path
          data-name="Shape"
          d="M83.225 59.513v7.431a7.431 7.431 0 01-5.945 7.282c-1 .223 2.972.149-66.877.149a7.431 7.431 0 01-7.431-7.431v-7.431a7.431 7.431 0 017.431-7.431 185.325 185.325 0 0130.469-2.974 189.026 189.026 0 0134.925 2.972 7.431 7.431 0 017.431 7.431z"
          fill="#c81e1e"
        />
        <path
          data-name="Shape"
          d="M78.766 59.51v7.431a7.431 7.431 0 01-5.945 7.282c-1 .223 2.631.149-62.419.149a7.431 7.431 0 01-7.43-7.428V59.51a7.431 7.431 0 017.431-7.431 185.324 185.324 0 0130.469-2.969 185.325 185.325 0 0130.466 2.972 7.431 7.431 0 017.428 7.428z"
          fill="#f44335"
        />
        <path
          data-name="Shape"
          d="M19.32 63.229a5.216 5.216 0 11-2.436-4.372 5.187 5.187 0 012.436 4.372zM77.281 63.229a5.216 5.216 0 11-2.436-4.372 5.187 5.187 0 012.436 4.372z"
          fill="#fdd834"
        />
        <path
          data-name="Shape"
          d="M11.89 67.911a5.172 5.172 0 010-9.363 5.172 5.172 0 010 9.363zM69.85 67.911a5.172 5.172 0 010-9.363 5.172 5.172 0 010 9.363z"
          fill="#ffeb3a"
        />
        <rect
          data-name="Rectangle-path"
          width={29.674}
          height={10.174}
          rx={2}
          transform="translate(28.188 58.077)"
          fill="#fec108"
        />
        <rect
          data-name="Rectangle-path"
          width={25.435}
          height={10.174}
          rx={2}
          transform="translate(28.188 58.077)"
          fill="#ffdc00"
        />
        <path
          data-name="Shape"
          d="M75.794 52.082a186.307 186.307 0 00-32.7-2.972 186.306 186.306 0 00-32.691 2.972c2.318-9.278 1.323-5.573 4.458-16.347 5.945-7.862 50.53-7.877 56.474 0 3.137 10.774 2.141 7.059 4.459 16.347z"
          fill="#00bcd4"
        />
        <path
          data-name="Shape"
          d="M66.878 35.735c3.136 10.775 2.185 7.267 4.265 15.56 2.972.446 4.652.788 4.652.788-2.318-9.274-1.323-5.573-4.458-16.348-3.983-5.306-23.779-6.093-30.466-5.945 6.018.208 22.381 1.115 26.007 5.945z"
          fill="#00838f"
        />
      </g>
      <path
        data-name="Shape"
        d="M15.605 57.96a6.688 6.688 0 106.688 6.688 6.688 6.688 0 00-6.688-6.688zm0 10.4a3.715 3.715 0 113.712-3.712 3.715 3.715 0 01-3.712 3.712zM73.565 57.96a6.688 6.688 0 106.688 6.688 6.688 6.688 0 00-6.688-6.688zm0 10.4a3.715 3.715 0 113.712-3.712 3.715 3.715 0 01-3.712 3.712z"
      />
      <path
        data-name="Shape"
        d="M83.225 44.585h-6.688c-2.482-8.531-2.3-8.01-2.526-8.323-1.486-2.021-4.785-3.418-8.62-4.384v-5.127H77.28a4.459 4.459 0 004.458-4.458V4.458A4.458 4.458 0 0077.28 0H11.889a4.458 4.458 0 00-4.458 4.458v17.834a4.459 4.459 0 004.458 4.458h11.89v5.127c-3.834.966-7.1 2.363-8.62 4.384-.223.312 0-.208-2.526 8.323H5.945A5.927 5.927 0 004.34 56.222a8.917 8.917 0 00-1.367 4.711v7.431a8.917 8.917 0 005.945 8.382v7.966a4.459 4.459 0 004.458 4.458h8.917a4.459 4.459 0 004.458-4.458V77.28h35.668v7.431a4.459 4.459 0 004.458 4.458h8.917a4.459 4.459 0 004.458-4.458v-7.966a8.917 8.917 0 005.948-8.381v-7.431a8.917 8.917 0 00-1.367-4.711 5.927 5.927 0 00-1.605-11.637zM62.419 31.209a49.204 49.204 0 00-2.972-.49v-3.968h2.972zm-5.945-4.458v3.626a109.635 109.635 0 00-23.779 0v-3.626zM10.4 22.292V4.458a1.486 1.486 0 011.486-1.486H77.28a1.486 1.486 0 011.486 1.486v17.834a1.486 1.486 0 01-1.486 1.486H11.889a1.486 1.486 0 01-1.489-1.486zm16.348 4.458h2.972v4c-1 .134-1.991.3-2.972.49zm-9.066 11.1c3.27-3.671 18.146-5.157 26.9-5.157s23.63 1.412 26.9 5.157c2.972 10.4 2.17 7.3 3.8 13.777a184.359 184.359 0 00-61.408 0c1.62-6.45.728-3.2 3.8-13.777zM2.972 50.53a2.972 2.972 0 012.972-2.972h5.945l-1.129 4.458A8.917 8.917 0 006.985 53.5h-1.04a2.972 2.972 0 01-2.973-2.97zm20.807 34.181a1.486 1.486 0 01-1.487 1.489h-8.917a1.486 1.486 0 01-1.486-1.486V77.28h11.89zm53.5 0a1.486 1.486 0 01-1.485 1.489h-8.917a1.486 1.486 0 01-1.486-1.486V77.28H77.28zm5.945-16.348a5.945 5.945 0 01-5.945 5.945c-70.206 0-65.748 0-66.565-.119a5.945 5.945 0 01-4.771-5.826v-7.43a5.945 5.945 0 015.945-5.945h.163a.4.4 0 00.134 0 186.35 186.35 0 0132.4-2.972 188.476 188.476 0 0132.7 2.972 5.945 5.945 0 015.945 5.945zm2.1-15.738a2.972 2.972 0 01-2.1.877h-1.04a8.917 8.917 0 00-3.73-1.486l-1.174-4.459h5.945a2.972 2.972 0 012.1 5.068z"
      />
      <path
        data-name="Shape"
        d="M56.474 57.96H32.695a4.458 4.458 0 00-4.458 4.458v4.458a4.459 4.459 0 004.458 4.458h23.779a4.459 4.459 0 004.463-4.457v-4.459a4.459 4.459 0 00-4.463-4.458zm1.486 8.917a1.486 1.486 0 01-1.486 1.483H32.695a1.486 1.486 0 01-1.486-1.486v-4.456a1.486 1.486 0 011.486-1.486h23.779a1.486 1.486 0 011.486 1.486zM31.209 17.09c0-2.972-2.972-5.2-6.688-5.2-2.229 0-3.715-1.174-3.715-2.229s1.486-2.229 3.715-2.229 3.713 1.172 3.713 2.226a1.486 1.486 0 001.486 1.486c2.972 0 1.486-6.688-5.2-6.688-3.714.002-6.686 2.291-6.686 5.202s2.972 5.2 6.688 5.2c2.185 0 3.715 1.174 3.715 2.229s-1.486 2.229-3.715 2.229-3.715-1.174-3.715-2.229a1.486 1.486 0 00-1.486-1.486c-2.972 0-1.486 6.688 5.2 6.688 3.713.003 6.688-2.286 6.688-5.199zM33.632 22.188a1.486 1.486 0 001.932-.832l1.412-3.522h6.3l1.413 3.523a1.488 1.488 0 002.764-1.1L41.509 5.394a1.486 1.486 0 00-2.764 0l-5.95 14.863a1.486 1.486 0 00.832 1.932zm6.494-12.246l1.962 4.915h-3.923zM50.529 22.292h7.431a1.486 1.486 0 000-2.972h-5.945V5.944a1.486 1.486 0 00-2.972 0v14.862a1.486 1.486 0 001.486 1.486zM62.419 22.292h7.431a1.486 1.486 0 000-2.972h-5.945v-4.462h4.458a1.486 1.486 0 000-2.972h-4.458V7.43h5.945a1.486 1.486 0 000-2.972h-7.431a1.486 1.486 0 00-1.486 1.486v14.862a1.486 1.486 0 001.486 1.486z"
      />
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
